function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.02 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-right-double") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Date-Dropdown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Give-Again-Arrow-Copy",
    d: "M10.34,8.23,3.16,15.41a.6.6,0,0,1-.44.18.6.6,0,0,1-.43-.18L.68,13.8a.58.58,0,0,1-.18-.43.62.62,0,0,1,.18-.44L5.82,7.8.68,2.66A.6.6,0,0,1,.5,2.22a.6.6,0,0,1,.18-.43L2.29.18A.6.6,0,0,1,2.72,0a.6.6,0,0,1,.44.18l7.18,7.18a.6.6,0,0,1,.18.44A.6.6,0,0,1,10.34,8.23Z",
    transform: "translate(-0.5)",
    style: {
      fill: "#2774ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Give-Again-Arrow-Copy-2",
    d: "M17.34,8.23l-7.18,7.18a.6.6,0,0,1-.44.18.6.6,0,0,1-.43-.18L7.68,13.8a.58.58,0,0,1-.18-.43.62.62,0,0,1,.18-.44L12.82,7.8,7.68,2.66a.6.6,0,0,1-.18-.44.6.6,0,0,1,.18-.43L9.29.18A.6.6,0,0,1,9.72,0a.6.6,0,0,1,.44.18l7.18,7.18a.6.6,0,0,1,.18.44A.6.6,0,0,1,17.34,8.23Z",
    transform: "translate(-0.5)",
    style: {
      fill: "#2774ae"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDouble);
export default __webpack_public_path__ + "static/media/arrow-right-double.83e10e2b70b8af339ad3fdddb3258c64.svg";
export { ForwardRef as ReactComponent };